const RECEIPT_KEY='tradelog-purchase-confirmation';
const SEEN_KEY='tradelog-purchase-welcome-seen';
export function savePurchaseReceipt(receipt,storage){
  if(!receipt||typeof receipt.attempt!=='string'||typeof receipt.proof!=='string')return;
  try{(storage||window.sessionStorage).setItem(RECEIPT_KEY,JSON.stringify(receipt));}catch{}
}
export function readPurchaseReceipt(storage){
  try{const value=JSON.parse((storage||window.sessionStorage).getItem(RECEIPT_KEY)||'null');return typeof value?.attempt==='string'&&/^[a-f0-9-]{36}$/.test(value.attempt)&&typeof value.proof==='string'&&/^[-_A-Za-z0-9]{43}$/.test(value.proof)?value:null;}catch{return null;}
}
export function purchaseWelcomeSeen(id,storage){try{return (storage||window.sessionStorage).getItem(SEEN_KEY)===id;}catch{return false;}}
export function markPurchaseWelcomeSeen(attempt,storage){try{(storage||window.sessionStorage).setItem(SEEN_KEY,`paid-welcome:${attempt}`);}catch{}}

export function trialWelcomeSeen(attempt){try{return window.sessionStorage.getItem('tradelog-trial-welcome-seen')===attempt;}catch{return false;}}
export function markTrialWelcomeSeen(attempt){try{window.sessionStorage.setItem('tradelog-trial-welcome-seen',attempt);}catch{}}
